/* global $:false */

export default class HomeOfficeTrigger {
  static init () {
    Array.from($('.js-topmenu__home-office-trigger')).map((el) =>
      new HomeOfficeTrigger(el))
  }

  constructor (el) {
    this.el = $(el)
    this.dialog = $('.js-home-office-selector')
    this.closeButton = $('.js-home-office-selector__close')
    this.readDataAttributes()
    this.setupShowDialogLink()
    this.setupCloseDialogButton()
    if (this.cookieNotSet() && this.atStartPage()) { this.showDialog() }
  }

  cookieName () {
    return 'ho'
  }

  cookieNotSet () {
    return document.cookie.indexOf(this.cookieName()) === -1
  }

  readDataAttributes () {
    this.url = this.closeButton.data('url')
  }

  storeNotSet () {
    $.ajax({
      url: this.url,
      data: { office: 0 },
      type: 'post'
    })
  }

  hideDialog () {
    this.dialog.css('visibility', 'hidden')
  }

  showDialog () {
    this.dialog.css('visibility', 'visible')
    this.hideSlideMenu()
  }

  setupShowDialogLink () {
    this.el.click(event => {
      event.preventDefault()
      event.stopPropagation()
      this.showDialog()
    })
  }

  setupCloseDialogButton () {
    this.closeButton.click(event => {
      event.preventDefault()
      event.stopPropagation()
      if (this.cookieNotSet()) { this.storeNotSet() }
      this.hideDialog()
    })
  }

  atStartPage () {
    if (['/sv', '/fi', '/en'].includes(window.location.pathname)) { return true }
    return false
  }

  // Improve experience on mobile, close the side menu
  hideSlideMenu () {
    const slideMenu = $('.o-slidebar--expanded')
    if (!slideMenu) { return }
    slideMenu.removeClass('o-slidebar--expanded')
  }
}
